import { render } from "./DeviceManagement.vue?vue&type=template&id=287adde9&scoped=true&ts=true"
import script from "./DeviceManagement.vue?vue&type=script&lang=ts"
export * from "./DeviceManagement.vue?vue&type=script&lang=ts"

import "./DeviceManagement.vue?vue&type=style&index=0&id=287adde9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287adde9"]])

export default __exports__